import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-expense-management-tabs',
  templateUrl: './expense-management-tabs.component.html',
  styleUrls: ['./expense-management-tabs.component.scss']
})
export class ExpenseManagementTabsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/expense-management-tabs/expense-management-tabs.component.ts